registerGlobal( 'EmscriptenFacebook' );

EmscriptenFacebook.initializeIAP = function(cb, arg) {
    if (EmscriptenFacebook.delayCallAfterInit(EmscriptenFacebook.initializeIAP, [cb, arg])) return;
    FB.api('/me/?fields=currency', function(data) {
        if (!data || data.error) {
            setTimeout(function() { EmscriptenFacebook.initializeIAP(cb, arg); }, 250);
            return;
        }

        // sometimes FB doesn't send currency at all
        if (data.currency == null) {
            data.currency = {
                currency_offset: 100,
                usd_exchange: 1,
                usd_exchange_inverse: 1,
                user_currency: "USD"
            };
        }
        EmscriptenFacebook._currency = data.currency;

        dynCall('vi', cb, [arg]);
    });

}


EmscriptenFacebook.purchase = function(_product, _product_url, _request_id, quantity, cb, errcb, arg) {
    var product = UTF8ToString(_product);
    var product_url = UTF8ToString(_product_url);
    var request_id = UTF8ToString(_request_id);
    var stringToStackPointer = function(str) {
        return allocate(intArrayFromString(String(str)), 'i8', ALLOC_STACK);
    }

    var callback = function(result) {
        if (!cb) return;

        if (!result || 'error_code' in result) {
            result = result || {}
            var error_code = 'error_code' in result ? result.error_code : 0;
            var error_message = 'error_message' in result ? result.error_message : '';
            var stack = Module.stackSave();
            dynCall('viiiii', errcb, [arg, stringToStackPointer(product), result.quantity, error_code, stringToStackPointer(error_message)]);
            Module.stackRestore(stack);
            return;
        }

        var status = 'status' in result ? result.status : 'unknown';
        var payment_id = 'payment_id' in result ? result.payment_id : 'unknown';
        var stack = Module.stackSave();
        dynCall('viiiii', cb, [arg, stringToStackPointer(product), result.quantity, stringToStackPointer(status), stringToStackPointer(payment_id)]);
        Module.stackRestore(stack);
    };

    FB.ui({
            method: 'pay',
            action: 'purchaseitem',
            request_id: request_id,
            product: product_url,
            quantity: quantity,
        },
        callback
    );
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/inappstore/emscripten/facebook/js/Application.facebookiap.js
// module id = 55
// module chunks = 0